<template>
    <ModalComponent
        :name="'UpdateVoucher-' + voucher.id"
        title="Editar Cupón"
        v-on:close="close"
    >
        <FormVoucher :voucher="data" :session_id="session_id" :event_id="event_id" />

        <div slot="footer">
            <Button type="button" class="mr-3" @click="update" :disabled="loading" id="guardar-cupon">GUARDAR</Button>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import FormVoucher from "@/components/backend/eventos/FormVoucher";

    export default {
        props: ['event_id', 'session_id', 'voucher'],
        data() {
            return {
                loading: false,
                data: this.voucher
            }
        },
        methods: {
            update() {
                const params = {
                    filters : {},
                    voucher: this.data,
                    event_id: this.event_id,
                    session_id: this.session_id,
                    voucher_id: this.data.id
                };
                
                this.$store.dispatch(this.config.getVuexAlias('back.events.voucher.update'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                    this.close();
                }).finally(() => this.loading = false);

            },
            close(editado = false) {
                this.$emit('close', 'UpdateVoucher-' + this.voucher.id, editado);
            },
        },
        components: {
            ModalComponent, FormVoucher
        }
    }
</script>
